module.exports = __webpack_public_path__ + "img/logo-dkib.88360ff8.svg";